/**
 * 指定範囲の数値配列を返却
 * @returns [start, ..., end - 1]
 */
export const range = (start: number = 0, end: number) => {
  return [...Array(end - start).keys()].map((i) => i + start)
}
